export default function () {
  return {
    items: [],
    inventoryRows: [],
    rowsFormData: [],
    suppliersInfo: {},
    itemSales: {},
    supplierPaymentTerms: {},
    vendorProductsInventory: {}
  };
}
